/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
exports.onRouteUpdate = ({ location, prevLocation }) => {
    console.log('new pathname', location.pathname)
    console.log('old pathname', prevLocation ? prevLocation.pathname : null)
    let targetEl = document.querySelector('header h1 a');
    if (location.pathname === '/resume/') {
        console.log('r');
        targetEl.innerHTML = 'Matt Wojas Resume'
    } else {
        targetEl.innerHTML = 'Matt Wojas Website'
    }
  }